export function useShortsSpeedState() {
	const isHolding = useState<boolean>('shorts-speed-holding', () => false);

	function notifyHoldingChange(holding: boolean): void {
		isHolding.value = holding;
	}

	return {
		isHolding,
		notifyHoldingChange
	};
}
